import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from 'src/types/KeyCloak';

export interface IUserState {
  userdataavailable: any;
  user?: IUser;
  currentDate: string;
  currentTime: string;
}

const initialState: IUserState = {
  currentDate: '',
  currentTime: '',
  userdataavailable: null
};

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserState: state => {
      state.user = undefined;
      state.currentDate = '';
      state.currentTime = '';
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.token = action.payload.token;
        state.user.sponsorToken = action.payload.sponsorToken;
        state.user.siteToken = action.payload.siteToken;
      }
    },
    setPreferences: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.preferences = action.payload;
      }
    },
    setUserDataAvailable: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.userdataavailable = action.payload;
      }
    },
    setUserDocPermissions: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.userdocpermissions = action.payload;
      }
    }
  }
});

export const { clearUserState, setUser, setToken, setPreferences, setUserDataAvailable, setUserDocPermissions } =
  user.actions;
